/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {shallowEqual, useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import {UserModel} from 'app/modules/auth/models/UserModel'
import {RootState} from 'redux/store'
// import {Languages} from './Languages'
// import * as auth from 'app/modules/auth/redux/AuthRedux'
import {useDispatch} from 'react-redux'
import {toAbsoluteUrl} from '_metronic/helpers'
import {logout} from 'redux/actions/auth-action'
import {useIntl} from 'react-intl'

const HeaderUserMenu: FC = () => {
  const intl = useIntl()
  const user: UserModel = useSelector<RootState>(
    ({auth}: any) => auth.user,
    shallowEqual
  ) as UserModel

  const dispatch = useDispatch()

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-325px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img
              alt='Logo'
              src={
                user.profileImage?.trim() != '' && user.profileImage?.trim() != null
                  ? user.profileImage
                  : toAbsoluteUrl('/media/avatars/default-user.png')
              }
            />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>{user.name}</div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {user.username}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2' />

      <div className='menu-item px-5'>
        <Link to={'/profile'} className='menu-link px-5'>
          {intl.formatMessage({id: 'MENU_LINK_PROFILE'})}
        </Link>
      </div>

      <div className='separator my-2' />

      <div className='menu-item px-5'>
        <span onClick={() => dispatch(logout())} className='menu-link px-5'>
          {intl.formatMessage({id: 'MENU_LINK_SIGN_OUT'})}
        </span>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
